import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'auth';

export interface ICognitoUserStatus {
  email: string;
  status: string;
  enabled: boolean;
  verified: boolean;
}

/** Cognito account controls (admin-only on the server). Moved from the app's services/user-auth.service.ts. */
@Injectable({ providedIn: 'root' })
export class AdminAuthApiService {
  private readonly http = inject(HttpClient);

  status(email: string): Observable<ICognitoUserStatus> {
    return this.http.get<ICognitoUserStatus>(`${API_URL}/${encodeURIComponent(email)}`);
  }

  enable(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_URL}/enable`, { email });
  }

  disable(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_URL}/disable`, { email });
  }

  /** Emails the user a new temporary password (they choose a new one at next sign-in). */
  sendTemporaryPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_URL}/temporary-password`, { email });
  }
}
